module.exports = __webpack_public_path__ + "static/media/activity-agreed.f1fdedaa.svg";